import React, {useEffect, useState} from 'react'
import {
    useMultiStyleConfig,
    Text,
    VStack,
    Box,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import GridTemplate from '../../../components/grid-template'
import GridCard from '../../../components/grid-card'
import {FormattedMessage} from 'react-intl'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import PropTypes from 'prop-types'
import routingObject from '../../../utils/static-routes'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {decodeHtmlEntities} from '../../../utils/utils'

export default function SubCategoriesList({
    setGoBackText,
    setGoBackToPath,
    selectedCategory,
    listOfCategories,
}) {
    const navigate = useNavigation()
    const [content, setContent] = useState([])
    const styles = useMultiStyleConfig('Faq', {})
    const {categoriesCardStyles} = styles || {}
    const [showFAQcatTitle, setShowFAQcatTitle] = useState(true)
    const {locale} = useMultiSite()

    useEffect(() => {
        const topics = Object.values(selectedCategory?.topics || {})
        setContent(topics)
    }, [selectedCategory])

    const formatCategoryName = (categoryName) => {
        return (
            categoryName &&
            decodeHtmlEntities(categoryName).trim().replace(/\s+/g, '-').replace(/[?]/g, '')
        )
    }

    const buildUrl = (categoryName, categoryId, parentId) => {
        let cleanName = formatCategoryName(categoryName)
        let parentName = formatCategoryName(listOfCategories?.data?.[parentId]?.category_name)
        let cleanId = formatCategoryName(categoryId)

        return `${routingObject.FAQ_PATH}/${parentName}/${cleanName}/t/${cleanId}`
    }

    const handleCatSelection = (category_id, category_name, category_topics, parent_id) => {
        setShowFAQcatTitle(false)

        if (category_topics && Object.keys(category_topics).length !== 0) {
            let subTopics = Object.values(category_topics)
            setGoBackText('default')
            setGoBackToPath(routingObject.FAQ_PATH)
            setContent(subTopics)
        } else {
            navigate(buildUrl(category_name, category_id, parent_id))
        }
    }

    return (
        <VStack w="100%" h="100%">
            <VStack {...categoriesCardStyles?.categoriesCardContainer}>
                {showFAQcatTitle && (
                    <Text {...categoriesCardStyles?.categoriesTitle}>
                        <FormattedMessage
                            id="faq_page.categories_grid.title_message"
                            defaultMessage="Search by category to find frequently asked questions about your product."
                        />
                    </Text>
                )}
                {content.length > 0 && (
                    <GridTemplate variant="faqs">
                        {content.map((cat, idx) => (
                            <Box
                                category-url={`/${locale?.alias}${buildUrl(
                                    cat?.category_name,
                                    cat?.category_id,
                                )}`}
                                w="100%"
                                textAlign="center"
                                key={idx}
                                onClick={() =>
                                    handleCatSelection(
                                        cat?.category_id,
                                        cat?.category_name,
                                        cat?.topics,
                                        cat?.parent_id,
                                    )
                                }
                            >
                                <GridCard
                                    title={cat?.category_name}
                                    image={cat?.category_icon}
                                    variant="faqs"
                                    onClick={() =>
                                        handleCatSelection(
                                            cat?.category_id,
                                            cat?.category_name,
                                            cat?.topics,
                                            cat?.parent_id,
                                        )
                                    }
                                />
                            </Box>
                        ))}
                    </GridTemplate>
                )}
            </VStack>
        </VStack>
    )
}

SubCategoriesList.propTypes = {
    setGoBackText: PropTypes.func,
    setGoBackToPath: PropTypes.func,
    setHasSubcategory: PropTypes.func,
    selectedCategory: PropTypes.object,
    listOfCategories: PropTypes.object,
}
